import { 
    Tabs, 
    Tab,
    TableContainer,
    Table,
    TableHead,
    TableRow,
    styled,Card,
    TableBody,
    Grid,
    OutlinedInput,
    InputAdornment,
    Paper,
    Badge,
    TableCell
} from "@mui/material";
import { useEffect, useState } from "react";
import { useTheme } from '@mui/material/styles';
import Label from "src/components/Label";
import { serverDetails } from "src/api/servers";
import Iconify from "src/components/Iconify";
// import Card from "src/theme/overrides/Card";
// import {
//     UserListToolbar,
//   } from "../../src/sections/@dashboard/user";
import { UserListToolbar } from "../@dashboard/user";
export default function CameraDetails({ serverInfo }) {
    const theme = useTheme();
    const tabListSx = {
        border: `1px solid ${theme.palette.divider}`,
        backgroundColor: theme.palette.background.neutral,
        '& .MuiTab-root': { color: theme.palette.text.secondary },
        '& .MuiTab-root.Mui-selected': { color: theme.palette.text.primary },
        '& .MuiTabs-indicator': { backgroundColor: theme.palette.primary.main },
    };

    const [cameraData, setCameraData] = useState({
        all: [],
        activeCameras: [],
        inActiveCameras: []
    });
    const [filterName, setFilterName] = useState("");  
    const [selectedTab, setSelectedTab] = useState(0);

    const CustomTableCell = styled(TableCell)({
        padding: 10,
    });

    const CameraTableCell = styled(TableCell)({
        padding: 10,
        borderRight: "1px solid rgb(211 211 211)",
        borderBottom: "1px solid rgb(211 211 211)"
    });

    useEffect(() => {
        serverDetails(serverInfo.Id, (response) => {
            if (response.status === 200) {
                const activeCamera = [];
                const inActiveCameras = [];
                const all = response.data.map((row) => {
                    if (row.Status === 1) activeCamera.push(row);
                    else inActiveCameras.push(row);
                    return row;
                });
                setCameraData({
                    all,
                    activeCameras: activeCamera,
                    inActiveCameras: inActiveCameras
                });
            }
        });
    }, [serverInfo]);

    
    const SearchStyle = styled(OutlinedInput)(({ theme }) => ({
        width: 240,
        marginLeft: 15,
        transition: theme.transitions.create(["box-shadow", "width"], {
            easing: theme.transitions.easing.easeInOut,
            duration: theme.transitions.duration.shorter
        }),
        "&.Mui-focused": { width: 320, boxShadow: theme.customShadows.z8 },
        "& fieldset": {
            borderWidth: "1px !important",
            borderColor: `${theme.palette.grey[500_32]} !important`
        }
    }));

    const handleFilterByName = (event) => {
        setFilterName(event.target.value); // Directly update the state
    };
    
    const getFilteredData = () => {
        let data = selectedTab === 0 ? cameraData.all :
                   selectedTab === 1 ? cameraData.activeCameras :
                   cameraData.inActiveCameras;
    
        const pattern = filterName.toLowerCase().trim(); // Convert input to lowercase
    
        if (pattern) {
            return data.filter((camera) =>
                (camera.devicename || "").toLowerCase().includes(pattern) ||
                (String(camera.deviceid || "")).toLowerCase().includes(pattern) ||
                (camera.displayname || "").toLowerCase().includes(pattern)
            );
        }
    
        return data;
    };
    

    const filteredCameras = getFilteredData();

    return (
      
<>
        <Card>
        
            <Tabs
            sx={tabListSx}
                value={selectedTab}
                onChange={(event, newValue) => setSelectedTab(newValue)}
                indicatorColor="primary"
                textColor="primary"
                aria-label="camera status tabs"
            >
                <Tab
                    label="All"
                    style={{ minHeight: "50px" }}
                    icon={
                        <Badge style={{ minHeight: "auto", marginLeft: "15px" }} badgeContent={String(cameraData.all.length)} color="primary" />
                    }
                    iconPosition="end"
                />
                <Tab
                    label="Active Cameras"
                    style={{ minHeight: "50px" }}
                    icon={
                        <Badge style={{ minHeight: "auto", marginLeft: "15px" }} badgeContent={String(cameraData.activeCameras.length)} color="success" />
                    }
                    iconPosition="end"
                />
                <Tab
                    label="Inactive Cameras"
                    style={{ minHeight: "50px" }}
                    icon={
                        <Badge style={{ minHeight: "auto", marginLeft: "15px" }} badgeContent={String(cameraData.inActiveCameras.length)} color="error" />
                    }
                    iconPosition="end"
                />
            </Tabs>

            <Grid container spacing={2} sx={{ marginTop: -1 , marginLeft: 0.5}}>
                {/* <SearchStyle
                    value={filterName}
                    onChange={handleFilterByName}
                    placeholder="Search"
                    startAdornment={
                        <InputAdornment position="start">
                            <Iconify icon="eva:search-fill" sx={{ color: "text.disabled", width: 20, height: 20 }} />
                        </InputAdornment>
                    }
                /> */}
                <UserListToolbar
                    sx={{ backgroundColor: theme.palette.background.neutral }}
                    // numSelected={selected.length}
                    filterName={filterName}
                    onFilterName={handleFilterByName}
                />


            </Grid>

            <TableContainer sx={{ maxHeight: 400 , marginTop: -1}} >
                <Table sx={{ border: "1px solid #e5e5e5" }} stickyHeader aria-label="sticky table">
                    <TableHead>
                        <TableRow>
                            <CustomTableCell>S.No</CustomTableCell>
                            <CustomTableCell>Camera Name</CustomTableCell>
                            <CustomTableCell>Device ID</CustomTableCell>
                            <CustomTableCell>Client Name</CustomTableCell>
                            <CustomTableCell>Category</CustomTableCell>
                            <CustomTableCell>Status</CustomTableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {filteredCameras.length > 0 ? (
                            filteredCameras.map((camera, index) => (
                                <TableRow key={index + 1}>
                                    <CameraTableCell>{index + 1}</CameraTableCell>
                                    <CameraTableCell>{camera.devicename}</CameraTableCell>
                                    <CameraTableCell>{camera.deviceid}</CameraTableCell>
                                    <CameraTableCell>{camera.displayname}</CameraTableCell>
                                    <CameraTableCell>{camera.Category}</CameraTableCell>
                                    <CameraTableCell>
                                        <Label variant="ghost" color={camera.Status === 1 ? "success" : "error"}>
                                            {camera.Status === 1 ? "Active" : "Inactive"}
                                        </Label>
                                    </CameraTableCell>
                                </TableRow>
                            ))
                        ) : (
                            <TableRow>
                                <CameraTableCell colSpan={6} align="center">No matching cameras found</CameraTableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
            </TableContainer>

        </Card>   
        </>
    );
}
